export function doesTourPaymentScheduleTemplateMatchLeadTime(
  paymentScheduleTemplate: App.Tours.TourPaymentScheduleTemplate,
  daysTillDeparture: number,
): boolean {
  const { leadTimeRange, minimumLeadDays } = paymentScheduleTemplate

  if (!leadTimeRange) {
    return daysTillDeparture >= minimumLeadDays
  }

  if (daysTillDeparture < leadTimeRange.minDays) {
    return false
  }

  if (leadTimeRange.maxDays !== undefined && daysTillDeparture > leadTimeRange.maxDays) {
    return false
  }

  return true
}

export default function getMatchingTourPaymentScheduleTemplate(
  paymentScheduleTemplates: Array<App.Tours.TourPaymentScheduleTemplate> | undefined,
  daysTillDeparture: number,
): App.Tours.TourPaymentScheduleTemplate | undefined {
  return paymentScheduleTemplates?.find((paymentScheduleTemplate) => {
    return doesTourPaymentScheduleTemplateMatchLeadTime(paymentScheduleTemplate, daysTillDeparture)
  })
}
